export default __webpack_public_path__ + "static/media/signup.6a4e5b71.svg";